import {areIntervalsOverlapping, format, lightFormat} from "date-fns";
import ru from "date-fns/locale/ru";


// --------

const rubFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
});

export function rubFmt(amount) {
    return rubFormatter.format(amount);
}

// --------

// https://stackoverflow.com/a/41716722
export function roundToOne(num) {
    return Math.round((num + Number.EPSILON) * 10) / 10;
}

// https://stackoverflow.com/a/41716722
export function roundToTwo(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
}

// --------

export function isoFmt(date) { return lightFormat(date, 'yyyy-MM-dd'); }
export function dmyFmt(date) { return lightFormat(date, 'dd.MM.yyyy'); }
export function dmyHmFmt(date) { return lightFormat(date, 'dd.MM.yyyy HH:mm'); }
export function dmyHmsFmt(date) { return lightFormat(date, 'dd.MM.yyyy HH:mm:ss'); }
export function dlyFmt(date) { return format(date, 'dd MMMM yyyy', {locale: ru}); } // TODO: better name?

export function formatDate2s(d) {
    return ("0" + d.getDate()).slice(-2) + "." + ("0" + (d.getMonth() + 1)).slice(-2) + "." + ("" + d.getFullYear()).slice(-2);
}

export function date1to2(str) {
    return str ? str.slice(8) + '.' + str.slice(5, 7) + '.' + str.slice(0, 4) : str;
}

export function date1to2s(str) {
    return str ? str.slice(8) + '.' + str.slice(5, 7) + '.' + str.slice(2, 4) : str;
}

export function parseDate2(str) {
    if (!(typeof (str) === "string") || !/^\d\d\.\d\d\.\d\d\d\d$/.test(str)) return undefined;
    const value = new Date(str.slice(6, 10) + '-' + str.slice(3, 5) + '-' + str.slice(0, 2));
    if (isNaN(value.valueOf())) return undefined;
    return value;
}

export function parseDate(str) {
    if (str instanceof Date)
        return new Date(str);
    else if (/^\d\d\d\d-\d\d-\d\d$/.test(str))
        return new Date(str);
    else if (/^\d\d\.\d\d\.\d\d\d\d$/.test(str))
        return new Date(str.slice(6, 10) + '-' + str.slice(3, 5) + '-' + str.slice(0, 2));
        // else if (/^\d\d\.\d\d\.\d\d$/.test(str))
    //     return new Date('20' + str.slice(6, 8) + '-' + str.slice(3, 5) + '-' + str.slice(0, 2));
    else
        return undefined;
}

// --------

export function uniteIntervals(intervalX, intervalY) {
    // you can leave out the new Date() constructor, because later differenceInMinutes can accept numbers
    return {
        start: new Date(Math.min(intervalX.start, intervalY.start)),
        end: new Date(Math.max(intervalX.end, intervalY.end))
    };
}

export function clampIntervals(intervals) {
    while (true) {
        let areOverlapping = false;
        let x, y;

        for (let i = 0; i < intervals.length - 1; ++i) {
            for (let j = i + 1; j < intervals.length; ++j) {
                if (areIntervalsOverlapping(intervals[i], intervals[j])) {
                    areOverlapping = true;
                    x = i;
                    y = j;
                    break;
                }
            }
        }

        if (!areOverlapping)
            break;

        let clampedIntervals = intervals.filter((item, index) => index !== x && index !== y);
        clampedIntervals.push(uniteIntervals(intervals[x], intervals[y]));

        intervals = clampedIntervals;
    }

    return intervals;
}

// --------

export function groupBy(array, keyfunc, returnMap = false) {
    const map = new Map();
    for (const item of array) {
        const key = keyfunc(item);
        const group = map.get(key);
        if (group)
            group.push(item);
        else
            map.set(key, [item]);
    }
    return returnMap ? map : Array.from(map.entries());
}

export function isMobile() {
    return (/Mobi|Android/i.test(navigator.userAgent));
}

// --------

// https://github.com/kulakowka/pluralize-ru
export const pluralize = (i, str0, str1, str2, str5) => {
    if (i === 0)
        return str0;
    else if (i % 10 === 1 && i % 100 !== 11)
        return str1;
    else if (i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20))
        return str2;
    else
        return str5;
};

// https://gist.github.com/paulvales/113b08bdf3d4fc3beb2a5e0045d9729d
// ACHTUNG: one important 'if' was removed
export const ageToStr = (age) => {
    let txt;
    let count = age % 100;
    if (count >= 5 && count <= 20)
        txt = 'л.';
    else {
        count %= 10;
        if (count >= 1 && count <= 4)
            txt = 'г.';
        else
            txt = 'л.';
    }
    return age + txt;
}

// https://gist.github.com/clecuona/2945438
export const dateDiff = (dt1, dt2) => {
    const ret = {days: 0, months: 0, years: 0};

    // If the dates are equal, return the 'empty' object
    // if (dt1 === dt2)
    //     return ret;

    // Ensure dt2 > dt1
    if (dt1 > dt2) {
        const dtmp = dt2;
        dt2 = dt1;
        dt1 = dtmp;
    }

    // First get the number of full years
    const year1 = dt1.getFullYear();
    const year2 = dt2.getFullYear();

    const month1 = dt1.getMonth();
    const month2 = dt2.getMonth();

    const day1 = dt1.getDate();
    const day2 = dt2.getDate();

    // Set initial values bearing in mind the months or days may be negative
    ret['years'] = year2 - year1;
    ret['months'] = month2 - month1;
    ret['days'] = day2 - day1;

    // Now deal with the negatives
    // If the day difference is negative, e.g. dt2 = 13 oct, dt1 = 25 sept
    if (ret['days'] < 0) {
        // Use temporary dates to get the number of days remaining in the month
        const dtmp = new Date(dt1.getFullYear(), dt1.getMonth() + 1, 1, 0, 0, -1);
        const numDays = dtmp.getDate();
        ret['months'] -= 1;
        ret['days'] += numDays;
    }

    // If the month difference is negative
    if (ret['months'] < 0) {
        ret['months'] += 12;
        ret['years'] -= 1;
    }

    return ret;
}

export const dateDiffString = (diff) => {
    const {years, months, days} = diff;
    const res = [];
    if (years)
        res.push(ageToStr(years));
    if (months)
        res.push(months + 'м.');
    if (days)
        res.push(days + 'д.');
    return res.join(' ');
}

// --------

export function omitKeys(object, keys) {
    const subset = {};
    for (const key in object) if (!keys.includes(key) && object[key]) subset[key] = object[key];
    return subset;
}

export function leaveKeys(object, keys) {
    const subset = {};
    for (const key of keys) if (object[key]) subset[key] = object[key];
    return subset;
}

export function mapValues(object, fn) {
    const result = {};
    for (const key in object) result[key] = fn(object[key], key);
    return result;
}

// --------

export function debounce(func, timeout = 300) {
    let timer;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

// --------

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
export function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// --------

// https://stackoverflow.com/a/60467595
//  Formatted version of a popular md5 implementation
//  Original copyright (c) Paul Johnston & Greg Holt.
//  The function itself is now 42 lines long.
export function md5(inputString) {
    var hc="0123456789abcdef";
    function rh(n) {var j,s="";for(j=0;j<=3;j++) s+=hc.charAt((n>>(j*8+4))&0x0F)+hc.charAt((n>>(j*8))&0x0F);return s;}
    function ad(x,y) {var l=(x&0xFFFF)+(y&0xFFFF);var m=(x>>16)+(y>>16)+(l>>16);return (m<<16)|(l&0xFFFF);}
    function rl(n,c)            {return (n<<c)|(n>>>(32-c));}
    function cm(q,a,b,x,s,t)    {return ad(rl(ad(ad(a,q),ad(x,t)),s),b);}
    function ff(a,b,c,d,x,s,t)  {return cm((b&c)|((~b)&d),a,b,x,s,t);}
    function gg(a,b,c,d,x,s,t)  {return cm((b&d)|(c&(~d)),a,b,x,s,t);}
    function hh(a,b,c,d,x,s,t)  {return cm(b^c^d,a,b,x,s,t);}
    function ii(a,b,c,d,x,s,t)  {return cm(c^(b|(~d)),a,b,x,s,t);}
    function sb(x) {
        var i;var nblk=((x.length+8)>>6)+1;var blks=new Array(nblk*16);for(i=0;i<nblk*16;i++) blks[i]=0;
        for(i=0;i<x.length;i++) blks[i>>2]|=x.charCodeAt(i)<<((i%4)*8);
        blks[i>>2]|=0x80<<((i%4)*8);blks[nblk*16-2]=x.length*8;return blks;
    }
    var i,x=sb(""+inputString),a=1732584193,b=-271733879,c=-1732584194,d=271733878,olda,oldb,oldc,oldd;
    for(i=0;i<x.length;i+=16) {olda=a;oldb=b;oldc=c;oldd=d;
        a=ff(a,b,c,d,x[i+ 0], 7, -680876936);d=ff(d,a,b,c,x[i+ 1],12, -389564586);c=ff(c,d,a,b,x[i+ 2],17,  606105819);
        b=ff(b,c,d,a,x[i+ 3],22,-1044525330);a=ff(a,b,c,d,x[i+ 4], 7, -176418897);d=ff(d,a,b,c,x[i+ 5],12, 1200080426);
        c=ff(c,d,a,b,x[i+ 6],17,-1473231341);b=ff(b,c,d,a,x[i+ 7],22,  -45705983);a=ff(a,b,c,d,x[i+ 8], 7, 1770035416);
        d=ff(d,a,b,c,x[i+ 9],12,-1958414417);c=ff(c,d,a,b,x[i+10],17,     -42063);b=ff(b,c,d,a,x[i+11],22,-1990404162);
        a=ff(a,b,c,d,x[i+12], 7, 1804603682);d=ff(d,a,b,c,x[i+13],12,  -40341101);c=ff(c,d,a,b,x[i+14],17,-1502002290);
        b=ff(b,c,d,a,x[i+15],22, 1236535329);a=gg(a,b,c,d,x[i+ 1], 5, -165796510);d=gg(d,a,b,c,x[i+ 6], 9,-1069501632);
        c=gg(c,d,a,b,x[i+11],14,  643717713);b=gg(b,c,d,a,x[i+ 0],20, -373897302);a=gg(a,b,c,d,x[i+ 5], 5, -701558691);
        d=gg(d,a,b,c,x[i+10], 9,   38016083);c=gg(c,d,a,b,x[i+15],14, -660478335);b=gg(b,c,d,a,x[i+ 4],20, -405537848);
        a=gg(a,b,c,d,x[i+ 9], 5,  568446438);d=gg(d,a,b,c,x[i+14], 9,-1019803690);c=gg(c,d,a,b,x[i+ 3],14, -187363961);
        b=gg(b,c,d,a,x[i+ 8],20, 1163531501);a=gg(a,b,c,d,x[i+13], 5,-1444681467);d=gg(d,a,b,c,x[i+ 2], 9,  -51403784);
        c=gg(c,d,a,b,x[i+ 7],14, 1735328473);b=gg(b,c,d,a,x[i+12],20,-1926607734);a=hh(a,b,c,d,x[i+ 5], 4,    -378558);
        d=hh(d,a,b,c,x[i+ 8],11,-2022574463);c=hh(c,d,a,b,x[i+11],16, 1839030562);b=hh(b,c,d,a,x[i+14],23,  -35309556);
        a=hh(a,b,c,d,x[i+ 1], 4,-1530992060);d=hh(d,a,b,c,x[i+ 4],11, 1272893353);c=hh(c,d,a,b,x[i+ 7],16, -155497632);
        b=hh(b,c,d,a,x[i+10],23,-1094730640);a=hh(a,b,c,d,x[i+13], 4,  681279174);d=hh(d,a,b,c,x[i+ 0],11, -358537222);
        c=hh(c,d,a,b,x[i+ 3],16, -722521979);b=hh(b,c,d,a,x[i+ 6],23,   76029189);a=hh(a,b,c,d,x[i+ 9], 4, -640364487);
        d=hh(d,a,b,c,x[i+12],11, -421815835);c=hh(c,d,a,b,x[i+15],16,  530742520);b=hh(b,c,d,a,x[i+ 2],23, -995338651);
        a=ii(a,b,c,d,x[i+ 0], 6, -198630844);d=ii(d,a,b,c,x[i+ 7],10, 1126891415);c=ii(c,d,a,b,x[i+14],15,-1416354905);
        b=ii(b,c,d,a,x[i+ 5],21,  -57434055);a=ii(a,b,c,d,x[i+12], 6, 1700485571);d=ii(d,a,b,c,x[i+ 3],10,-1894986606);
        c=ii(c,d,a,b,x[i+10],15,   -1051523);b=ii(b,c,d,a,x[i+ 1],21,-2054922799);a=ii(a,b,c,d,x[i+ 8], 6, 1873313359);
        d=ii(d,a,b,c,x[i+15],10,  -30611744);c=ii(c,d,a,b,x[i+ 6],15,-1560198380);b=ii(b,c,d,a,x[i+13],21, 1309151649);
        a=ii(a,b,c,d,x[i+ 4], 6, -145523070);d=ii(d,a,b,c,x[i+11],10,-1120210379);c=ii(c,d,a,b,x[i+ 2],15,  718787259);
        b=ii(b,c,d,a,x[i+ 9],21, -343485551);a=ad(a,olda);b=ad(b,oldb);c=ad(c,oldc);d=ad(d,oldd);
    }
    return rh(a)+rh(b)+rh(c)+rh(d);
}